<template>
  <div class="article_detail">
    <div class="banner">
      <img src="../../assets/images/pzbz/header.png" alt="" style="width: 100%;">
    </div>
    <section class="containers">
      <div class="heading">
        <h2>
          <label>{{ articleDetailInfo.title }}</label>
        </h2>
        <h4 style="display: flex;justify-content: flex-end;"><label>————{{ articleDetailInfo.subtitle }}</label></h4>
<!--        <p style="font-size: 16px;display: flex;justify-content: flex-start;margin-bottom: 40px;"-->
<!--           v-if="articleDetailInfo.createDate">发布时间：{{ articleDetailInfo.createDate.substring(0, 10) }}</p>-->
      </div>
<!--      <p><img :src="articleDetailInfo.image" alt="" style="display: block;margin: 0 auto 40px"></p>-->
      <div class="content" v-html="articleDetailInfo.counter"></div>
      <div class="back-btn-box">
        <el-button type="primary btn" @click="back">返回</el-button>
      </div>

    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      articleID: '175de576-edc0-0007-9262-b36d27e81509',
      articleDetailInfo: Object,
      type: '',
    };
  },
  methods: {
    async getDataByID() {
      // console.log(123888888888);
      var res = this.$http.getNewsById(this.articleID, {
        id: this.articleID
      });
      res.then((result) => {
        this.articleDetailInfo = result.result;
        console.log(res);
      });
    },
    back() {
      if(this.type == 1) {
      this.$router.push({path: '/index'})
      }else{
      this.$router.push({path: '/xwzx', query: {activeIndexStr: this.activeIndexStr}})
      }
    }
  },
  created() {
    this.articleID = this.$route.query.articleID;
    this.type = this.$route.query.type;

    this.getDataByID();
    // this.activeIndexStr = this.$route.query.activeIndexStr;
  },
  mounted() {
  }
}
</script>
<style lang="less" scoped>
.article_detail {
  background-color: #FAFAFA;
  padding-bottom: 100px;
  text-align: left;
  @media screen and (max-width: 768px) {
    padding-bottom: 0px;
  }
  @media screen and(min-width: 770px) {
    margin-top: 80px;
  }
  @media screen and(max-width: 770px) {
    margin-top: 50px;
  }
  .btn {
    width: 100px;
    height: 40px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
    margin: 0 auto;
    color: #FFFFFF;
    background-color: #E63019;
    border: none;
    outline: none !important;
    @media screen and (max-width: 768px) {
      width: 80px !important;
    }

  }

  .containers {
    position: relative;
    width: 940px;
    margin: 50px auto;
    margin-bottom: 80px;
    padding: 50px 100px 100px;
    background-color: #FFFFFF;
    outline: none;
    @media screen and (max-width: 768px) {
      width: 100%;
      margin: 0 auto ;
      padding: 10% 6% 20%;
    }

    .heading {
      h2 {
        color: #000000;
        line-height: 30px;
        text-align: center;
        @media screen and (max-width: 768px) {
          padding: 0;
          font-size: 20px;
        }
      }

      h4 {
        margin: 20px 0;
        @media screen and (max-width: 768px) {
          padding: 0;
          font-size: 16px;
        }

        p {
          @media screen and (max-width: 768px) {
            font-size: 12px !important;
          }
        }
      }

    }

    .content /deep/ {
      p {
        margin: 10px 0;
        color: #6C757D;
        h1, h2, h3, h4, h5, h6 {
          margin: 20px;
        }
        ul{
          list-style: disc;
        }
        ul li{
          list-style: disc;
          margin: 10px 0;
        }
        ol{
          list-style: decimal;
        }
        ol li{
          list-style: decimal;
          margin: 10px 0;
        }
        a{
          text-decoration: underline;
          color: #551a8b;
          font-weight: bold;
        }
        img {
          margin: 40px auto;
          display: block;
          width: auto;
          height: auto;
          @media screen and (max-width: 768px) {
            width: 100%;
            height: auto;
          }
        }
      }
    }

    .content /deep/ p {
      margin: 10px 0;
    }

    .content /deep/ img {
      margin: 40px auto;
      display: block;
      width: auto;
      height: auto;
    }
    .content /deep/ a {
      text-decoration: underline;
      color: #551a8b;
      font-weight: bold;
    }
    .content /deep/ h1, h2, h3, h4, h5, h6 {
      margin: 20px 0;
    }
    .content /deep/ ul {
      list-style: disc;
    }
    .content /deep/ ol{
      list-style: decimal;
    }
    .content /deep/ ul li{
      list-style: disc;
      margin: 10px 0;
    }
    .content /deep/ ol li{
      list-style: decimal;
      margin: 10px 0;
    }
  }
}

.back-btn-box {
  margin-top: 20px;
}
</style>
